<template>
    <div :id="$formatId(slice.id)" class="container content-space-b-1">
        <list-header-with-disclosure :h2="h2" :show-important-disclosure="showImportantDisclosure" />
        <div class="row">
            <credit-card 
                v-for="(card, index) in cards" 
                :key="card.id" 
                :card-id="card.id" 
                :position="index + 1"
            />
        </div>
    </div>
</template>
<script>
import { map } from 'lodash';
import CreditCard from '@/components/cards/CreditCard.vue';
import ListHeaderWithDisclosure from '@/components/ListHeaderWithDisclosure.vue';
export default {
    components: {
        CreditCard,
        ListHeaderWithDisclosure
    },
    props: {
        slice: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            cardsToShow: 12
        };
    },
    computed: {
        h2() {
            return this.$prismic.asText(this.slice.primary.h2)
                .replace('%count%', this.cards.length);
        },
        cards() {
            if (this.slice.primary.list.id) {
                return map(this.$store.state
                    .lists[this.slice.primary.list.id]
                    .data.items,
                'item').filter(item => this.$validateContentRelationship(item));
            }

            return map(this.slice.items, 'item')
                .filter(item => this.$validateContentRelationship(item));
        },
        topList() {
            return this.cards.slice(0, this.cardsToShow);
        },
        notShownList() {
            return this.cards.slice(this.cardsToShow);
        },
        showImportantDisclosure() {
            return !this.slice.primary.hide_important_disclosure;
        }
    }
};
</script>